module.exports = __webpack_public_path__ + "img/exercise.979eb095.svg";